export default __webpack_public_path__ + "static/media/AdobeStock_278648995_346317573.1248f8a4.jpg";